import 'bootstrap/dist/css/bootstrap.css';
import 'react-notifications-component/dist/theme.css'
import 'animate.css';
import './boostrap-override.css';
import './global-override.css';
import './Fontawesone-library.js';
import Router from "./Router";
import "./styles/main.scss"
import 'animate.css/animate.css'
import ThemeData from "./theme.js";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CookiesProvider } from "react-cookie";

const theme = createTheme(ThemeData);

function App() {
  return (
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <ThemeProvider theme={theme}>
        <Router />
      </ThemeProvider>
    </CookiesProvider>
  );
}

export default App;
